import { createInput, MountTarget, newDialog, readConfig } from './utils/elements';

export const HORNER_EDIT_SELECTOR = '.cds-lrn-horner';

interface HornerConfig {
  rows: number;
  columns: number;
}

export function hornerDialog(insertHtml: (html: string) => void, mountTarget?: MountTarget, existingEl?: HTMLElement) {
  const dialog = newDialog('Tabel van Horner maken', () => insertHtml(''), mountTarget);

  const rowInput = createInput('rows', 'Aantal rijen', 'number');
  rowInput.setValue('2');

  const columnInput = createInput('columns', 'Aantal kolommen', 'number');
  columnInput.setValue('4');

  if (existingEl) {
    const cfg = readConfig<HornerConfig>(existingEl, { rows: 2, columns: 4 });
    if (cfg.rows) rowInput.setValue(cfg.rows);
    if (cfg.columns) columnInput.setValue(cfg.columns);
  }

  dialog.querySelector('#cds-dialog-content').append(rowInput.field, columnInput.field);

  dialog.addEventListener('onSubmit', () => {
    const config: HornerConfig = { rows: +rowInput.value(), columns: +columnInput.value() };
    insertHtml(makeTable(config));
  });
}

function makeTable(config: HornerConfig) {
  const { rows, columns } = config;
  const table = document.createElement('table');
  table.classList.add('cds-lrn-horner', 'cds-lrn-editor-table', 'lrn_width_auto');
  table.setAttribute('data-cb-config', JSON.stringify(config));
  for (let r = 0; r < rows + 1; r++) {
    const row = document.createElement('tr');
    for (let c = 0; c < columns + 1; c++) {
      const cell = document.createElement('td');
      cell.classList.add('p-xs');
      if (c > 0) {
        cell.classList.add('border-is');
      }
      if (c === 1) {
        cell.classList.add('border-is-3');
      }
      if (r > 0 && c > 0) {
        cell.classList.add('border-bs');
      }
      if (r === rows) {
        cell.classList.add('border-bs-3');
      }
      if (r === rows - 1 && c === 0) {
        cell.innerHTML = 'placeholder';
        cell.classList.add('border-be', 'border-be-3');
      } else if (r === rows && c === columns) {
        cell.classList.add('border-is-5', 'border-bs-5');
        cell.innerHTML = 'restwaarde';
      } else if (c > 0 && !(c === 1 && r === rows - 1)) {
        cell.innerHTML = 'coëfficiënt';
      }

      row.append(cell);
    }
    table.append(row);
  }
  return table.outerHTML;
}
